// v3.3.749 — إدخال جوال موحّد ونظيف:
// • الأرقام العربية (٠١٢٣) تتحول تلقائيًا لإنجليزية أثناء الكتابة
// • لا فراغات ولا رموز — أرقام فقط (+ مسموحة في بداية الرقم الدولي)
// • السعودي: يجب 10 أرقام تبدأ بـ05 (أو ما يعادلها 9665...) — تظهر رسالة نقص واضحة
// • زر "🌍 دولي" بجانب الخانة يسمح بأي رقم خارجي بلا تحقق الطول السعودي
import React from "react";

const AR_DIGITS = "٠١٢٣٤٥٦٧٨٩";
const FA_DIGITS = "۰۱۲۳۴۵۶۷۸۹";

export const normalizePhone = (raw) => {
  let s = String(raw || "");
  let out = "";
  for (const ch of s) {
    const ai = AR_DIGITS.indexOf(ch);
    const fi = FA_DIGITS.indexOf(ch);
    if (ai >= 0) out += String(ai);
    else if (fi >= 0) out += String(fi);
    else out += ch;
  }
  // + مسموحة في البداية فقط، والباقي أرقام فقط (يزيل الفراغات والشرطات والأقواس)
  const plus = out.trim().startsWith("+") ? "+" : "";
  return plus + out.replace(/[^0-9]/g, "");
};

// يوحّد السعودي إلى الصيغة 05XXXXXXXX
export const canonicalSaudi = (p) => {
  const n = normalizePhone(p);
  const d = n.replace(/^\+/, "");
  if (/^9665\d{8}$/.test(d)) return "0" + d.slice(3);
  if (/^005665\d{8}$/.test(d)) return "0" + d.slice(5);
  if (/^5\d{8}$/.test(d)) return "0" + d;
  return n;
};

export const isSaudiComplete = (p) => /^05\d{8}$/.test(canonicalSaudi(p));

// يبدو سعوديًا (يبدأ 05/5/9665/+966) لكنه ناقص أو زائد
export const looksSaudiButInvalid = (p) => {
  const n = normalizePhone(p).replace(/^\+/, "");
  if (!n) return false;
  const saudiish = /^0?5/.test(n) || /^9665?/.test(n);
  return saudiish && !isSaudiComplete(p);
};

export const phoneError = (p, intl) => {
  const n = normalizePhone(p);
  if (!n) return null; // فارغ مسموح (الحقل اختياري)
  if (intl) {
    if (n.replace(/^\+/, "").length < 7) return "الرقم الدولي قصير جدًا";
    return null;
  }
  if (!isSaudiComplete(n)) return "الرقم السعودي يجب أن يكون 10 أرقام يبدأ بـ 05 (مثال: 0553633161)";
  return null;
};

export default function PhoneInput({ value, onChange, intl, onIntlChange, style = {}, placeholder, disabled }) {
  const err = phoneError(value, intl);
  return (
    <div>
      <div style={{ display: "flex", gap: 6 }}>
        <input
          value={value || ""}
          disabled={disabled}
          dir="ltr"
          inputMode="tel"
          placeholder={placeholder || (intl ? "+14155550123" : "05XXXXXXXX")}
          onChange={(e) => {
            let v = normalizePhone(e.target.value);
            if (!intl) v = canonicalSaudi(v);
            onChange(v);
          }}
          style={{
            flex: 1, padding: "7px 10px", borderRadius: 6, fontFamily: "inherit", fontSize: 12,
            outline: "none", boxSizing: "border-box", textAlign: "right",
            border: `1px solid ${err ? "#fca5a5" : "#e2e8f0"}`,
            background: err ? "#fef2f2" : "#fff",
            ...style,
          }}
        />
        <button type="button" disabled={disabled}
          onClick={() => onIntlChange && onIntlChange(!intl)}
          title={intl ? "التبديل لرقم سعودي (تحقق 05XXXXXXXX)" : "رقم غير سعودي — يسمح بأي رقم دولي"}
          style={{
            padding: "0 10px", borderRadius: 6, cursor: "pointer", fontFamily: "inherit",
            fontSize: 10.5, fontWeight: 700, whiteSpace: "nowrap", flexShrink: 0,
            border: `1px solid ${intl ? "#93c5fd" : "#e2e8f0"}`,
            background: intl ? "#eff6ff" : "#f8fafc",
            color: intl ? "#1d4ed8" : "#64748b",
          }}>
          {intl ? "🌍 دولي" : "🇸🇦 سعودي"}
        </button>
      </div>
      {err && <div style={{ fontSize: 9.5, color: "#dc2626", marginTop: 3, fontWeight: 600 }}>⚠️ {err}</div>}
    </div>
  );
}
